// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProposalStatusState } from "@/types/proposalStatus";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { ProposalStatus } from "@/models/proposalStatus";

const state: ProposalStatusState = {
  single: new ProposalStatus(),
  pagination: new Pagination(),
};

export const proposalStatus: Module<ProposalStatusState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
